import { Grid, Step, StepLabel } from '@material-ui/core';
import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { CoreApiContext } from '../../contexts/coreApiContext';
import SelectLanguage from '../SelectLanguage';
import {
  Container,
  ContainerHeader,
  GridOrdered,
  Logo,
  Row,
  Stepper,
  Title,
  Wrapper,
  WrapperSelectLanguage,
} from './styles';

function Header({ isHeaderStepper, showLogo, positionFixed, activeStep, completedStep, listStep }) {
  const { t } = useTranslation();

  const { getFeatureToggle } = useContext(CoreApiContext);
  const [featureTranslator, setFeatureTranslator] = useState(false);

  useEffect(() => {
    getFeatureToggle('mlabs_translator', setFeatureTranslator);
  }, []);

  return (
    <Container propPositionFixed={positionFixed}>
      <Wrapper>
        {isHeaderStepper ? (
          <Grid container>
            <Grid container justify="center" alignItems="center" item xs={6} md={2}>
              <Row size="large">
                <Logo />
                <Title component="h1" device="mobile" variant="h4">
                  {t('settings.title')}
                </Title>
              </Row>
            </Grid>

            {featureTranslator && (
              <GridOrdered container justify="flex-end" alignItems="center" item xs={6} md={2}>
                <SelectLanguage />
              </GridOrdered>
            )}

            <Grid container justify="center" alignItems="center" item xs={12} md={8}>
              <Row>
                <Title component="h1" device="desktop" variant="h4">
                  {t('settings.title')}
                </Title>
                <Stepper nonLinear activeStep={activeStep}>
                  {listStep?.map((label, index) => (
                    <Step key={label}>
                      <StepLabel completed={completedStep[index]}>{label}</StepLabel>
                    </Step>
                  ))}
                </Stepper>
              </Row>
            </Grid>
          </Grid>
        ) : (
          <ContainerHeader>
            {showLogo && <Logo />}
            {featureTranslator && (
              <WrapperSelectLanguage>
                <SelectLanguage />
              </WrapperSelectLanguage>
            )}
          </ContainerHeader>
        )}
      </Wrapper>
    </Container>
  );
}

export default Header;
